import { makeStyles } from "@mui/styles";

const testimonialStyle = makeStyles((theme) => ({
  boldText: {
    fontWeight: "600 !important",
    fontSize: "2rem !important",
  },
  hrLine: {
    height: "3px",
    width: "60px",
    backgroundColor: "#008374",
    margin: "0px auto",
  },
  testimonialCard: {
    backgroundColor: "#fff !important",
    padding: "30px",
    borderRadius: "10px",
    position: "relative",
    cursor: "pointer ",
    boxShadow: " 0px 0 15px rgb(0 0 0 / 10%) !important",
    margin: "0px 10px",
  },
  avatarSection: {
    display: "flex",
    "&.MuiBox-root .MuiTypography-h6": {
      fontSize: "18px !important",
      fontWeight: "bold !important",
      lineHeight: "none !important",
    },
    "&.MuiBox-root .MuiTypography-body2": {
      fontSize: "14px !important",
      color: "#999 !important",
      fontWeight: "600",
    },
    "&.MuiBox-root .MuiRating-sizeMedium": {
      marginLeft: "8px !important",
      fontSize: "22px !important",
      marginTop: "10px !important",
    },
  },
}));

export default testimonialStyle;
